import { FormikErrors } from 'formik';

import { FormSection } from '@@/form-components/FormSection';
import { FormControl } from '@@/form-components/FormControl';
import { Input } from '@@/form-components/Input';

import { FormValues } from '../types';

interface Props {
  namespace: string;
  releaseName: string;
  errors: FormikErrors<FormValues>;
  onNamespaceChange: (value: string) => void;
}

export function DeploymentSection({
  namespace,
  releaseName,
  errors,
  onNamespaceChange,
}: Props) {
  return (
    <FormSection title="Deploy to">
      <FormControl
        label="Namespace"
        errors={errors.kubeNamespace}
        required
        tooltip="Namespace to deploy the Helm chart to"
      >
        <Input
          value={namespace}
          onChange={(e) => onNamespaceChange(e.target.value)}
          placeholder="e.g. default"
          data-cy="helm-namespace-input"
        />
      </FormControl>

      <FormControl
        label="Release name"
        errors={errors.helmReleaseName}
        required
        tooltip="Automatically generated based on edge stack name (edge-<name>)"
      >
        <Input
          value={releaseName}
          onChange={() => {}} // No-op, read-only
          placeholder="e.g. edge-myapp"
          data-cy="helm-release-name-input"
          readOnly
          disabled
        />
      </FormControl>
    </FormSection>
  );
}
